
export const BuyerSubscriptionsCheck = new TypedDocumentString(`
    query BuyerSubscriptionsCheck($sellerIds: InputIds!) {
  buyerSubscriptionsCheck(sellerIds: $sellerIds) {
    items {
      ...BuyerSubscriptionsItem
      __typename
    }
    __typename
  }
}
    fragment BuyerSubscriptionsItem on BuyerSubscriptionsItem {
  id
  newsletter
  reviewRemindersEnabled
  __typename
}`, {"hash":"c2bf579c0cc507078930131d4a04e4bb1026cbb85953172b8f8eefd810a4f98f"});